var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"wrapper",attrs:{"id":"professionals"}},[_c('BoxMainView',{attrs:{"data":{
    image: 'professionals/img-mv.jpg',
    japanese: '挑戦者たち',
    title: 'professionals/txt-mv.svg',
  },"is-animation":_vm.isAnimate,"to-top":_vm.toTop,"is-fix":_vm.isFix,"is-professionals":true}}),_c('div',{staticClass:"wrapper__inner",class:{'is-animation': _vm.isAnimate, 'is-animation-end': _vm.isAnimateEnd}},[_c('section',{staticClass:"voices"},[_c('div',{staticClass:"voices__inner",attrs:{"id":"intro-inner"}},[_c('div',{staticClass:"voices__lead"},[_c('TextLead',{attrs:{"text":"「また会いたくなる場所」を創るため、それぞれのフィールドで活躍するプロフェッショナルたち。他では聞けない仕事への思いをお伝えします。"}})],1),_c('TitleLarge',{attrs:{"text":"VOICES <span>〜先輩インタビュー〜</span>"}}),_c('div',{staticClass:"voices__content"},[_c('ListVoices',{attrs:{"items":[
            {
              image: 'voice/01/img-photo.png',
              belong: 'ＪＲ九州ホテル ブラッサム那覇',
              title: '支配人',
              text: '自分たちにしかできないサービスで感動をお客さまとつくる。',
              spText: 'professionals/txt-professionals-01.svg',
              path: 'professionals/voice/01',
            },
            {
              image: 'voice/02/img-photo.png',
              belong: 'THE BLOSSOM HIBIYA',
              title: '支配人',
              text: '今やりたい事は、全部チャレンジできる。',
              spText: 'professionals/txt-professionals-02.svg',
              path: 'professionals/voice/02',
            },
            {
              image: 'voice/03/img-photo.png',
              belong: 'THE BLOSSOM KYOTO',
              title: 'マネージャ―',
              text: '旅行者目線に立ったサービスで、地域の魅力と共に歩む。',
              spText: 'professionals/txt-professionals-03.svg',
              path: 'professionals/voice/03',
            },
            {
              image: 'voice/04/img-photo.png',
              belong: 'ＪＲ九州ホテルブラッサム新宿',
              title: 'マネージャ―',
              text: '世界中からのお客さま、心やさしい仲間との出会いがある。',
              spText: 'professionals/txt-professionals-04.svg',
              path: 'professionals/voice/04',
            },
            {
              image: 'voice/05/img-photo.png',
              belong: '花べっぷ',
              title: 'ホテルスタッフ',
              text: '「目と気と心を配り、感動を咲かせる」を胸に日々まい進。',
              spText: 'professionals/txt-professionals-05.svg',
              path: 'professionals/voice/05',
            },
            {
              image: 'voice/06/img-photo.png',
              belong: '本社',
              title: '人事部マネージャー',
              text: '「おもてなしを通じて人を喜ばせるエンターテイナー」であれ。',
              spText: 'professionals/txt-professionals-06.svg',
              path: 'professionals/voice/06',
            },
            {
              image: 'voice/07/img-photo.png',
              belong: 'ＪＲ九州ホテル鹿児島',
              title: 'ホテルスタッフ',
              text: '多くの経験を積んで、自分にしかできないサービスを。',
              spText: 'professionals/txt-professionals-07.svg',
              path: 'professionals/voice/07',
            } ]}})],1)],1)]),_c('BoxEntry')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }